<template>
    <section class="table-section" v-loading="process.loading">
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0;">
            <!-- tool button -->
            <slot></slot>
            <el-form :inline="true" :model="search" @submit.native.prevent>
                <el-form-item>
                    <el-input size="medium" clearable v-model="search.search" @clear="handleSearch"
                              @keyup.native="debounced()"
                              :placeholder="('搜索')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="medium" type="primary" plain @click="handleSearch" icon="el-icon-search">
                        {{ ('搜索') }}
                    </el-button>
                </el-form-item>
                <el-form-item v-if="btn_add" class="ml-2">
                    <el-button size="medium" icon="el-icon-circle-plus-outline" type="primary" @click="handleAdd(0)">
                        {{ ('增加') }}{{ $route.meta ? ($route.meta.friendly) : '' }}
                    </el-button>
                </el-form-item>
            </el-form>

        </el-col>

        <!--列表-->
        <el-table :data="records" @sort-change="sortIsChange"
                  @selection-change="doSelect" @filter-change="doFilter" size="medium"
                  style="width: 100%;" :border="true" v-show="header.length">
            <el-table-column type="selection" width="55" :selectable="checkSelectable">
            </el-table-column>
            <el-table-column v-for="(item) in filter_header"
                             :width="item.width || 'auto'"
                             :key="item.key" :prop="item.key"
                             :label="english?(item.title_en?item.title_en:item.title):item.title"
                             :sortable="item.sortable?'custom':null"
                             :filters="item.filters?(english?(item.filters_en || item.filters):item.filters):null"
                             :filter-multiple="false">
                <template slot-scope="scope">
                    <div v-if="item.type==='picture'">
                        <div v-for="pic in scope.row[scope.column.property]"
                             :key="pic.id" style="display: inline-block;cursor: zoom-in;"
                             @click="handlePictureOpen(pic)">
                            <img :src="pic.thumbnail" style="height: 40px;margin-right: 5px;">
                        </div>
                    </div>
                    <div v-else v-html="scope.row[scope.column.property]"></div>
                </template>
            </el-table-column>
            <el-table-column :width="calculateWidth">
                <template slot="header">
                    <!--
                    <div class="float-right">
                            <el-popover placement="bottom"
                                        trigger="click">
                                <div class="px-2" style="width: 150px;">
                                    <b class="text-center d-block">图标说明</b>
                                    <div class="line"></div>
                                    <div v-for="x in buttons" :key="x.text" class="front-table-annotation">
                                        <el-button size="mini" circle :icon=x.icon :type="x.type"></el-button>
                                        <div>{{ x.text }}</div>
                                    </div>
                                </div>
                                <div slot="reference">
                                    <el-button size="mini" type="info" icon="el-icon-discover" title="图标说明"></el-button>
                                </div>
                            </el-popover>
                    </div>
                    -->
                    操作
                </template>
                <template slot-scope="scope">
                    <el-button v-if='btn_review' size="small" @click="handleReview(scope.$index, scope.row)" circle
                               icon="el-icon-search" title="查看"></el-button>
                    <el-button v-if='btn_edit' :disabled="scope.row.should_not_edit" size="small"
                               @click="handleEdit(scope.$index, scope.row)" circle icon="el-icon-edit"
                               title="编辑"></el-button>
                    <el-button v-if='btn_copy' type="info" size="small"
                               @click="handleCopy(scope.$index,scope.row)" circle
                               icon="el-icon-copy-document"></el-button>
                    <el-button v-if='btn_delete' :disabled="scope.row.should_not_edit" type="danger" size="small"
                               @click="handleDel(scope.$index, scope.row)" circle icon="el-icon-close"
                               title="删除"></el-button>
                    <el-button v-if='btn_download' type="info" size="small"
                               @click="handleDownload(scope.$index, scope.row)" circle
                               icon="el-icon-download" title="下载报表"></el-button>
                    <el-button v-if='btn_lock' type="warning" size="small" title="锁定会议"
                               @click="handleLock(scope.$index, scope.row)" circle icon="el-icon-lock"></el-button>
                    <el-button v-if='btn_unlock' type="success" size="small" title="开启会议"
                               @click="handleUnlock(scope.$index, scope.row)" circle icon="el-icon-unlock"></el-button>
                    <el-button v-if='btn_records' type="default" size="small" title="下载录像"
                               @click="handleRecords(scope.$index, scope.row)" circle icon="el-icon-upload"></el-button>
                    <el-button v-if='btn_poll' type="warning" size="small" circle icon="el-icon-s-claim" plain
                               :disabled="scope.row.should_not_edit" title="下载问卷"
                               @click="handlePoll(scope.$index, scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <slot name="footer"></slot>

            <el-button v-for="x in btn_extra_batch" :key="x.name" size="medium" :type="x.type" :icon="x.icon"
                       @click="handleExtraBatch(x)" :disabled="selects.length===0">
                {{ x.name }}
            </el-button>
            <el-button size="medium" v-if="btn_delete" type="danger" @click="handleBatchDel"
                       :disabled="selects.length===0"
                       icon="el-icon-delete">{{ ('批量删除') }}
            </el-button>
            <div class="d-flex pull-right">

                <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="page.size"
                               :current-page="page.current"
                               :page-sizes="[10,20,30,50,75,100]" @size-change="handleSizeChange"
                               :total="page.total" @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </el-col>

        <el-dialog v-picture-viewer
                   :visible.sync="show_pic"
                   append-to-body>
            <div style="max-height: calc( 80vh - 63px );max-width:100%;overflow: auto;" class="">
                <img :src="single.picture" class="large-image enlarge">
            </div>
        </el-dialog>
    </section>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: "front-table",
    data() {
        return {
            single: {},
            show_pic: false,
            is_first: true,
            selects: [],
            page: this.front_page,
            search: this.front_search,
            records: this.front_records,
            debounced: null,
            header: this.front_header,
        }
    },
    watch: {
        front_page: {
            handler(newVal) {
                this.page = newVal
            },
        },
        front_records: {
            handler(newVal) {
                this.records = newVal
            },
            deep: true
        },
        front_header: {
            handler(newVal) {
                this.header = newVal
            },
            deep: true
        },
        front_search: {
            handler(newVal) {
                this.search = newVal
            },
            deep: true
        },
    },
    props: {
        front_page: {
            type: Object,
            default() {
                return {}
            }
        },
        front_search: {
            type: Object,
            default() {
                return {}
            }
        },
        front_records: {
            type: Array,
            default() {
                return []
            }
        },
        front_header: {
            type: Array,
            default() {
                return []
            }
        },
        model: {
            type: String,
            default() {
                return '';
            }
        },
        btn_review: {
            type: Boolean,
            default() {
                return false;
            }
        },
        btn_add: {
            type: Boolean,
            default() {
                return true;
            }
        },
        btn_edit: {
            type: Boolean,
            default() {
                return true;
            }
        },
        btn_delete: {
            type: Boolean,
            default() {
                return true;
            }
        },
        btn_copy: {
            type: Boolean,
            default() {
                return false;
            }
        },
        btn_download: {
            type: Boolean,
            default() {
                return false;
            }
        },
        btn_lock: {
            type: Boolean,
            default() {
                return false;
            }
        },
        btn_unlock: {
            type: Boolean,
            default() {
                return false;
            }
        },
        btn_records: {
            type: Boolean,
            default() {
                return false;
            }
        },
        btn_poll: {
            type: Boolean,
            default() {
                return false;
            }
        },
        btn_extra_batch: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    methods: {
        checkSelectable(row) {
            return (!row.should_not_edit);
        },
        doSelect(selection) {
            this.selects = selection;
        },
        sortIsChange(column) {
            this.search.sort = {'prop': column.prop, 'order': column.order};
            this.$emit('reload', this.search);
        },
        doFilter(filters) {
            this.search.filters = Object.assign({}, this.search.filters, filters);
            this.$emit('reload', this.search);
        },
        handleEdit(index, row) {
            this.handleAdd(row.id);
        },
        handleAdd(id) {
            this.$emit('edit', id);
        },
        handleDownload(index, row) {
            this.$emit('download', row.id);
        },
        handleLock(index, row) {
            this.$emit('lock', row.id);
        },
        handleUnlock(index, row) {
            this.$emit('unlock', row.id);
        },
        handleCopy(index, row) {
            this.$emit('copy', row.id);
        },
        handleReview(index, row) {
            this.$emit('review', row.id);
        },
        handleRecords(index, row) {
            this.$emit('records', row.id);
        },
        handlePoll(index, row) {
            this.$emit('poll', row.id);
        },
        handleDel: function (index, row) {
            this.$confirm(('您确认删除该记录吗'), ('提示'), {
                type: 'warning',
                dangerouslyUseHTMLString: true

            }).then(() => {
                this.$api(this.model + '.Delete', {id: row.id}, true)
                    .then(() => {
                        this.$notify({
                            message: ('删除记录成功!'),
                            type: 'success'
                        });
                        this.$emit('reload', this.search);
                    });
            }).catch(() => {
            });
        },
        handleBatchDel: function () {
            let vm = this;
            this.$confirm(('您确认删除这些记录吗?'), ('信息'), {
                type: 'warning',
                dangerouslyUseHTMLString: true

            }).then(() => {
                this.$api(vm.model + '.Delete', {ids: vm.selects.map(i => i.id)}, true)
                    .then(() => {
                        this.$notify({
                            message: ('删除记录成功!'),
                            type: 'success'
                        });
                        this.$emit('reload', this.search);
                    });
            }).catch(() => {
            });
        },
        handleCurrentChange(val) {
            this.search.page = val;
            console.log('page change', val, this.search.page);
            this.$emit('reload', Object.assign({}, this.search));
        },
        handleSizeChange(val) {
            this.search.page_size = val;
            this.$emit('reload', this.search);
        },
        handleSearch() {
            this.$emit('reload', this.search);
        },
        handlePictureOpen(pic) {
            this.single = pic;
            this.show_pic = true;
        },
        handleExtraBatch(item) {
            this.$emit('extra', {item: item, ids: this.selects.map(i => i.id)});
        },
    },
    computed: {
        ...mapState(['process']),
        defaultSort() {
            let order = {};
            if (this.header.length > 0) {
                this.header.forEach(h => {
                    if (h.default) {
                        order = {prop: h.key, order: h.default === 'asc' ? 'ascending' : 'descending'};
                    }
                });
            }
            return order;
        },
        filter_header() {
            return this.header.filter(function (item) {
                return !item.hidden;
            })
        },
        english() {
            return false;
        },
        calculateWidth() {
            let width = (this.btn_download ? 1 : 0) + (this.btn_review ? 1 : 0) + (this.btn_edit ? 1 : 0) + (this.btn_copy ? 1 : 0) + (this.btn_delete ? 1 : 0) +
                (this.btn_lock ? 1 : 0) + (this.btn_unlock ? 1 : 0) + (this.btn_poll ? 1 : 0) + (this.btn_records ? 1 : 0);
            if (width === 1) width = 1.25;
            if (width === 0) width = 1;
            return width * 50;
        },
        buttons() {
            let buttons = [];
            if (this.btn_review) buttons.push({text: '查看', icon: 'el-icon-search', type: 'default'});
            if (this.btn_edit) buttons.push({text: '编辑', icon: 'el-icon-edit', type: 'default'});
            if (this.btn_copy) buttons.push({text: '复制', icon: 'el-icon-copy-document', type: 'info'});
            if (this.btn_delete) buttons.push({text: '删除', icon: 'el-icon-close', type: 'danger'});
            if (this.btn_download) buttons.push({text: '报告', icon: 'el-icon-download', type: 'info'});
            if (this.btn_records) buttons.push({text: '录像', icon: 'el-icon-upload', type: 'default'});
            return buttons;
        }
    },
    mounted() {
        let vm = this;
        this.debounced = this.$debounce(1000, function () {
            vm.$emit('reload', vm.search);
        });
    },
}
</script>

<style lang="scss">

.table-section {
    //border: 1px solid #ccc !important;

    .toolbar {
        position: relative;
        font-size: 12px;
        border: 1px solid #ebeef5;

        background: #fff;
        padding: 5px 10px;
        //border:1px solid #dfe6ec;
        margin: 10px 0;

        .el-form-item {
            margin-bottom: 5px;
        }
    }

    .el-table {
        thead {
            tr {
                background-color: #d9e5f1;

                th {
                    color: #37474f;
                    background-color: #d9e5f1;

                    .cell {
                        line-height: 34px;
                    }

                    .el-table__column-filter-trigger {
                        float: right;
                    }

                    i.el-icon-arrow-down {
                        transform: scale(1.3);
                        //margin-left: 5px;
                        transition: all 0.1s ease-in;

                        &:before {
                            content: "\e6ca";
                        }

                        &:hover {
                            transform: scale(1.8);
                            color: #3794ff;
                        }
                    }

                    .highlight {
                        i.el-icon-arrow-down {
                            color: #3794ff;
                        }
                    }
                }
            }
        }
    }
}

.front-table-annotation {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 5px;
    margin-top: 5px;
}

.large-image {
    cursor: zoom-out;

    &.enlarge {
        max-width: 100%;
        max-height: calc(80vh - 63px);
        cursor: zoom-in;
    }
}

</style>
